export const en = {
    cancel: 'Cancel',
    'crop-all-sizes': 'Crop all sizes',
    'crop-title': 'Cropping image',
    'crop-updated-sizes': 'Crop updated sizes'
};
